import {Button, Autocomplete, Grid, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import axios from 'axios'
import _ from 'lodash'
import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Helmet } from 'react-helmet-async'
import dayjs from 'dayjs'
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from 'moment'
import { setSnackbar } from '../../../../../../components/hooks/snackBar/reducers'
import { useStyle } from '../../../billing/style'
import CustomTable from '../../customTable'
import * as XLSX from 'xlsx';
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';

const AllOutletStockLedger = () => {
    const dispatch = useDispatch()
    const classes = useStyle()
    const [data, setData] = useState([])
    const pageOption = [10, 25, 50, 100];
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
    const [pageCount, setPageCount] = useState(0);
    const [catData,setCatData] = useState([])
    const [subData,setSubData] = useState([])
    const [headData, setHeadData] = useState([])
    const [typeData, setTypeData] = useState([])
    const [supplier, setSupplier] = useState([]);
    const [outletName , setOutletName]=useState([])
    const [options, setOptions] = useState({
        customer:null,
        head: null,
        type: null,
        category : null,
        subCategory : null,
        fromDate: moment().subtract(1 , 'years' ).format(),
        toDate :  moment().format()
    })

    function handleChange(value, name){
        console.log(name, value)
        if (name === 'fromDate' || name === 'toDate') {
          // If the name is fromDate or toDate, format the date with dayjs
          const formattedDate = dayjs(value).format('YYYY-MM-DD');
          setOptions(prev => ({ ...prev, [name]: formattedDate }));
      } else {
          // For other fields, set directly
          setOptions(prev => ({ ...prev, [name]: value }));
      }
    }
    function getItemData(){
      const allItems = {
        from_date : moment(options.fromDate).format('YYYY-MM-DD'),
        to_date :  moment(options.toDate).format('YYYY-MM-DD'),
        customer:options.customer===null ? 0 : options.customer.id,
        category:options.category===null ? 0 : options.category.id,
        subcategory:options.subCategory===null ? 0 : options.subCategory.id,
        type:options.type===null ? 0 : options.type.id,
        head:options.head===null ? 0 : options.head.id
      }
        // axios.post(`/v1/reports/item/${options.head===null ? 0 : options.head.id}/${options.type===null ? 0 : options.type.id}/${options.category===null ? 0 : options.category.id}/${options.subCategory===null ? 0 : options.subCategory.id}/${rowsPerPage}/${page + 1}`)
        axios.post(`/v1/reports/stock/ledger/all_outlet_sales` ,allItems)
        .then(res=>{
          setOutletName(res.data[0].outlets_names_header);
          const responseData = res.data.slice(1);
          if (responseData.length > 0) {
              setData(responseData);
          } else {
          }
        })
        .catch(err=>{
          console.log(err)
          if(err.response.data.errors[0].message === "INTERNAL_SERVER_ERROR"){
            dispatch(setSnackbar(true,'error',"Data not found"))
            setData([])
          }else{
            dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
            setData([])
          }
        })
    }
    function getHead(){
        axios.get('/v1/Head')
        .then(res=>{
            setHeadData(res.data)
        })
        .catch(err=>{
          console.log(err)
            dispatch(setSnackbar(true,'error',err.response.error))
        })
    }
    function getTypeData(){
        axios.get('/v1/typedesign')
        .then(res=>{
            setTypeData(res.data)
        })
        .catch(err=>{
            dispatch(setSnackbar(true,'error',err.response.error))
        })
    }
    function getCategory(){
        axios.get('/v1/categories')
        .then(res=>{
            _.filter(res.data, val=>{
                if(val.is_active){
                     setCatData(res.data)
                }
            })
        })
        .catch(err=>{
            console.log(err.response.data.error)
            dispatch(setSnackbar(true,'error',err.response.data.error))
        })
    }
    function getSubCategory(){
        axios.get('/v1/subcategories')
        .then(res=>{
                setSubData(res.data)
        })
        .catch(err=>{
            console.log(err.response.data.error)
            dispatch(setSnackbar(true,'error',err.response.data.error))
        })
    }
    function getSupplierData() {
      axios
        .get("/v1/outlet/list/1")
        .then((res) => {
          console.log(res.data)
          setSupplier(res.data);
        })
        .catch((err) => {
          dispatch(setSnackbar(true, "error", err.response.data.error));
        });
    }
    function exportToExcel() {
      const wb = XLSX.utils.book_new();
      
      // Prepare the data for Excel
      const excelData = [
        // Headers
        [
            'S.no',
            'Product Name',
            'Product Code',
            'Brand',
            'Type',
            'Category',
            'Subcategory',
            'Total Qty',
            'Total Amount',
            ...outletName.flatMap(outlet => [
                `${outlet.outlet_name}`,
                `${outlet.outlet_name}`,
               
            ])
        ],
        // Subheaders for Qty and Amount
        [
            '', // Empty cell for the first main header
            '', // Empty cell for the second main header
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            ...outletName.flatMap(outlet => [
                'Qty', // Bold text for Qty
                'Amount', // Bold text for Amount
            ])
        ],
        // Data rows
        ...data.map((value, idx) => [
            idx + 1,
            value.pro_name || "-",
            value.pro_code || "-",
            value.head_name || "-",
            value.type_name || "-",
            value.category_name || "-",
            value.subcategory_name || "-",
            value.total_qty || "-",
            parseFloat(value.total_amount).toFixed(0) || "-",
            ...outletName.flatMap(outlet => {
                const outletDetail = value.outlet_details.find(detail => detail.outlet_code === outlet.outlet_code);
                return [
                    outletDetail ? outletDetail.qty || "-" : "-",
                    outletDetail ? parseFloat(outletDetail.amount).toFixed(0) || "-" : "-"
                ];
            })
        ])
    ];
    
      const ws = XLSX.utils.aoa_to_sheet(excelData);
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, "Outlet all stock ledger.xlsx");
    }
    useEffect(()=>{
        getCategory()
        getSubCategory()
        getHead()
        getTypeData()
        getSupplierData()
    },[])
    useEffect(()=>{
        getItemData()
    },[rowsPerPage, page, options])
  return (
    <Fragment>
      <Helmet><title> All Outlet Sales Stock Ledger</title></Helmet>
            <Typography variant="h5">All Outlet Sales Stock Ledger</Typography>
    <Grid container spacing={2} className='p-2 pt-2'>
    <Grid item md={3}>
          <Autocomplete 
            size="small"
            options={[{id:0 ,fullname : "All"} , ...supplier]}
            onChange={(e,value)=>handleChange(value,'customer')}
            getOptionLabel={option=>option.fullname}
            renderInput={(params) => <TextField {...params} label="Select Outlet"/>}
          />
        </Grid>
    <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(options.fromDate)}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'},
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(options.toDate)}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
    <Grid item md={3}>
      <Autocomplete 
        size='small'
        value={options.head}
        options={headData}
        getOptionLabel={option=>option.cateogory_name}
        onChange={(e,value)=>handleChange(value,'head')}
        renderInput={(params)=>(
            <TextField {...params}
            label='Brand'/>
          )}
        />
      </Grid>
      <Grid item md={3}>
      <Autocomplete 
        size='small'
        options={typeData}
        value={options.type}
        getOptionLabel={option=>option.type_name}
        onChange={(e,value)=>handleChange(value,'type')}
        renderInput={(params)=>(
            <TextField {...params}
            label='Type Design'/>
          )}
        />
      </Grid>
      <Grid item md={3}>
      <Autocomplete 
        size='small'
        value={options.category}
        options={catData}
        getOptionLabel={option=>option.category_name}
        onChange={(e,value)=>handleChange(value,'category')}
        renderInput={(params)=>(
            <TextField {...params}
            label='Category'/>
          )}
        />
      </Grid>
      <Grid item md={3}>
      <Autocomplete 
        size='small'
        options={subData}
        value={options.subCategory}
        getOptionLabel={option=>option.subcategory_name}
        onChange={(e,value)=>handleChange(value,'subCategory')}
        renderInput={(params)=>(
            <TextField {...params}
            label='Sub Category'/>
          )}
        />
      </Grid>
    </Grid>
    <Grid className='text-end my-2'>
    <Button onClick={exportToExcel} variant="outlined" > Export to Excel <SimCardDownloadOutlinedIcon /></Button>
      </Grid>
    <TableContainer className={classes.tblRoot} sx={{ maxHeight:700 }}>
      <Table stickyHeader aria-label="sticky table">
        <TableHead className={classes.tblHeader} sx={{position: "sticky",top: 0,}}>
          <TableRow className={classes.tablrow}>
              <TableCell rowSpan={2} sx={{minWidth:70}}>S.no</TableCell>
              <TableCell  rowSpan={2} sx={{minWidth:250}}>Product Name</TableCell>
              <TableCell  rowSpan={2} sx={{minWidth:150}}>Product Code</TableCell>
              <TableCell  rowSpan={2} sx={{minWidth:150}}>Brand </TableCell>
              <TableCell  rowSpan={2} sx={{minWidth:150}}>Type </TableCell>
              <TableCell  rowSpan={2} sx={{minWidth:150}}>Category </TableCell>
              <TableCell  rowSpan={2} sx={{minWidth:150}}>Subcategory </TableCell>
              <TableCell rowSpan={2} sx={{minWidth:70}}>Total Qty</TableCell>
              <TableCell rowSpan={2} sx={{minWidth:130}}>Total Amount</TableCell>
              {_.map(outletName , (val,idx) => (
                 <React.Fragment key={idx}>
                  <TableCell colSpan={2} sx={{minWidth:180}}>{val.outlet_name || "-"}</TableCell>
                  </React.Fragment>
              ))}
          </TableRow>
          <TableRow  className={classes.tablrow}>
          {_.map(outletName, (val, idx) => (
            <React.Fragment key={idx}>
                <TableCell>Quantity</TableCell>
                <TableCell>Amount</TableCell>
            </React.Fragment>
        ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {_.map(data , (value, idx) => (
            <TableRow key={idx}  className={classes.tablrow}>
              <TableCell>{idx + 1}</TableCell>
              <TableCell>{value.pro_name || "-"}</TableCell>
              <TableCell>{value.pro_code || "-"}</TableCell>
              <TableCell>{value.head_name || "-"}</TableCell>
              <TableCell>{value.type_name || "-"}</TableCell>
              <TableCell>{value.category_name || "-"}</TableCell>
              <TableCell>{value.subcategory_name || "-"}</TableCell>
              <TableCell>{value.total_qty || "-"}</TableCell>
              <TableCell sx={{ textAlign: "right !important",fontWeight:"bold" }}>{parseFloat(value.total_amount).toFixed(0) || "-"}</TableCell>
              {outletName.map((outlet, index) => {
                const outletDetail = value.outlet_details.find(detail => detail.outlet_code === outlet.outlet_code);
                return (
                  <React.Fragment key={index}>
                    <TableCell>{outletDetail ? outletDetail.qty || "-" : "-"}</TableCell>
                    <TableCell sx={{ textAlign: "right !important",fontWeight:"bold" }}>{outletDetail ? parseFloat(outletDetail.amount).toFixed(0) || "-" : "-"}</TableCell>
                  </React.Fragment>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>

    </TableContainer>
    </Fragment>
  )
}

export default AllOutletStockLedger